module.exports = __webpack_public_path__ + "static/img/PU products discription2_deskstop.eeb49f50.jpg";